import { updateSelectedVehicle } from "api/garage/updateSelectedVehicle";
import { RootState } from "interfaces/generics.type";
import { Dispatch } from "redux";
import { ISelectVehicleAction } from "../interfaces/garage.interface";
import { ILoaderActionTypes } from "../interfaces/loader.interface";
import { setVehicleDetails } from "../utils/setVehicleDetails";

export function clearSelection() {
  return (dispatch: Dispatch<ISelectVehicleAction | ILoaderActionTypes, RootState>) => {
    dispatch(setVehicleDetails(null));
    // no parameters to signify no vehicle
    updateSelectedVehicle(null);
    dispatch({
      type: "SELECT_VEHICLE",
      data: null,
    });
  };
}
